import { render, staticRenderFns } from "./TextInfo.vue?vue&type=template&id=d6d34c1a&scoped=true"
import script from "./TextInfo.vue?vue&type=script&lang=js"
export * from "./TextInfo.vue?vue&type=script&lang=js"
import style0 from "./TextInfo.vue?vue&type=style&index=0&id=d6d34c1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d34c1a",
  null
  
)

export default component.exports